import React from 'react';
import { MapPin } from 'lucide-react';
import { calcItemPrice, formatMoney } from './calc';

const CartSummary = ({ config, cart, draft }) => {
  const items = [...cart, draft].filter((it) => it.service_type);
  if (!items.length) return null;

  const priced = items.map((it) => ({ item: it, price: calcItemPrice(it, config) }));
  const total = priced.reduce((s, p) => s + (p.price?.total || 0), 0);

  return (
    <div className="cart-summary" data-testid="cart-summary">
      <h3 className="cart-summary-title">Your Booking</h3>
      {priced.map(({ item, price }, idx) => (
        <div key={idx} className="cart-summary-item">
          <div className="cart-summary-head">
            <span className="cart-summary-service">
              {price?.serviceLabel || config.services.find((s) => s.key === item.service_type)?.label}
            </span>
            <span className="cart-summary-price">
              {price ? formatMoney(price.total) : '—'}
            </span>
          </div>
          {item.address && (
            <span className="cart-summary-address"><MapPin size={12} /> {item.address}</span>
          )}
          {price?.addonLines.length > 0 && (
            <span className="cart-summary-addons">
              {price.addonLines.map((a) => a.label + (a.qty > 1 ? ` ×${a.qty}` : '')).join(', ')}
            </span>
          )}
        </div>
      ))}
      <div className="cart-summary-total" data-testid="cart-summary-total">
        <span>Estimated Total</span>
        <span>{formatMoney(total)}</span>
      </div>
      <p className="cart-summary-note">Pay securely at the final step. No hidden fees.</p>
    </div>
  );
};

export default CartSummary;
